export const ArtworkStatus = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  PUBLISHED: 'PUBLISHED'
}

export const UserRole = {
  ARTIST: 'ARTIST',
  MANAGER: 'MANAGER'
}

export const UploadStatus = {
  QUEUED: 'QUEUED',
  UPLOADING: 'UPLOADING',
  FAILED: 'UPLOAD FAILED',
  DONE: 'UPLOAD SUCCEEDED'
}



// WEBPACK FOOTER //
// ./src/api/enums.js